function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.648,
    height: 12,
    viewBox: "0 0 9.648 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11059",
    d: "M15.167 19H9V7h5.667a3.5 3.5 0 0 1 2.667 5.767A3.5 3.5 0 0 1 15.167 19zM11 17h4.153a1.5 1.5 0 0 0 0-3H11zm0-5h3.667a1.5 1.5 0 1 0 0-3H11z",
    transform: "translate(-9 -7)",
    style: {
      fill: "#203662"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldBlue);
export default __webpack_public_path__ + "static/media/BoldBlue.2a837b5b0c64b26de8f4fcac97dacfe8.svg";
export { ForwardRef as ReactComponent };